import { render } from "./particules.vue?vue&type=template&id=1ba2ef4a&scoped=true"
import script from "./particules.vue?vue&type=script&lang=js"
export * from "./particules.vue?vue&type=script&lang=js"

import "./particules.vue?vue&type=style&index=0&id=1ba2ef4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba2ef4a"]])

export default __exports__